import React from 'react';
import './GameState.css';

export default function WhoseTurn({players, playersTurn, endGame, gameOver, winningPlayerIndex}) {
  let color=players[playersTurn].color;
  return (
    <>
    {endGame === false && gameOver === false && <h1 style={{color}} className="Heading">{players[playersTurn].name}'s turn</h1>}
    {endGame === true  && <h1 className="Heading" style={{color}}>{players[playersTurn].name}'s last turn</h1>}
    {gameOver === true && <h1 className="Heading" style={{color}}>{players[winningPlayerIndex].name} won!</h1>}
    </>
  )
}
